import styled from 'styled-components';

export const Content = styled.div`
  .root-input,
  .root-select {
    margin-bottom: 16px;
  }
`;
